import React, {useState, useEffect} from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Shine from '../assets/Shine.svg'
import Checkmark from '../assets/checkmark-circle.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'
import ToastNotification from '../components/ToastNotification'
import { courseTitleFormat } from '../utils';
import TutorialsLoader from '../components/loaders/TutorialsLoader';

const FoundationIndex = () => {

    const [course, setCourse] = useState([]);
    const [fullAccess, setFullAccess] = useState(false);
    const [serverMessage, setServerMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const fetchCourseData = async () => {
        try {
            const response = await fetch(`${apiUrl}/videos/foundation/foundation/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();
            if (data.success) {
                setCourse(data.courseVideos);
                await getUserSubscription();
                // Hide loader with timeout for smooth transition
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);
            } else {
                //call serverMessage component to show error message
                setServerMessage(data);
                console.error('Error fetching course data:', data.message);
            }
        }
        catch (error) {
            console.error('Error while fetching course data:', error);
        }
    }

    // Must handle course lock down logic based on this but be careful if user is not logged in
    const getUserSubscription = async () => {
        try {
            const response = await fetch(`${apiUrl}/subscription/verify-access/`, {
                method: 'GET',
                credentials: 'include', // Include cookies in the request
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if (data.success) {
                // Handle the subscription data as needed
                setFullAccess(data.success);
            }

        } catch (error) {
            console.error('Error while verifying user subscription access but course data should be fetched:', error);
            throw error; // Propagate the error to the caller
        }
    }

    useEffect(() => {
        fetchCourseData();
    }, []);

    
    return (
        <div className="wrapper">
            <div id="content-wrap">
                <Navbar />  
                <div className="d-flex flex-column justify-content-center align-items-center" style={{marginTop: "100px"}}> 
                    <h2>Foundation</h2>
                    <p className='text-center w-50' style={{minWidth: "320px", maxWidth: "685px"}}>Choose section to start. Structure order from top to bottom is recommended.</p>
                    <div className='d-flex pt-2'>
                        <img src={Shine} alt='Shine' className='pe-1' />
                        <img src={Shine} alt='Shine' className='pe-1' />
                        <img src={Shine} alt='Shine' className='pe-1' />
                    </div>
                </div>
                {isLoading ? (
                    <TutorialsLoader />
                ) : (
                    <div className='d-flex flex-column justify-content-center align-items-center mb-5'>
                        {course.map((item, index) => (
                            <div key={index} className='d-flex flex-column w-50 rounded mt-4' style={{minWidth: "320px", maxWidth: "685px", border: "1px solid #AEAFBA", backgroundColor: "rgba(0, 0, 0, 0.3)"}}>
                                <p className='m-0 p-3' style={{fontWeight: '400'}}>{courseTitleFormat(item.section)}</p>
                                {/* Straight line */}
                                <div style={{width: "100%", height: "1px", backgroundColor: "#AEAFBA"}}></div>
                                {item.videos.map((video, videoIndex) => (
                                    <div 
                                        key={videoIndex} 
                                        className='d-flex justify-content-between ps-3 pt-3' 
                                        style={{cursor: video.free_trial || fullAccess ? "pointer" : "not-allowed"}}
                                        onClick={video.free_trial || fullAccess ? () => navigate('/tutorials/foundation/video/' + video.id) : null} // Disable onClick if not free_trial
    
                                    >
                                        <p className='m-0' style={{fontWeight: '200'}}>{video.name}</p>
                                        {!video.free_trial && !fullAccess && (
                                            <FontAwesomeIcon icon={faLock} className='me-3' style={{ color: '#AEAFBA' }} />
                                        )}
                                    </div>
                                ))}
                                <div className='pt-3'></div>
                            </div>
                        ))}
                        <div className='mt-5'></div>
                    </div>
                )}
            </div>
            <Footer />
            {/* Toast Notification */}
            <ToastNotification
              message={serverMessage} 
              setServerMessage={() => setServerMessage(null)} // Clear the message after displaying it
            />
        </div>
    )
}

export default FoundationIndex